<template>
  <div class="document">
    <!--region PAGE 1-->
    <ExportationViewerPage :total="pageTotal" page="1">
      <ExportationFrameHeader v-bind="{ headerInformations }" />

      <ExportationFrameRunningChartBanner v-bind="{ aggregates, displayMetrics, norms }" class="top-margin" />

      <ExportationFrameRunningChartSpeedCadenceDetailled
        v-if="detailledRunningMode && showDetails"
        class="top-margin-lg"
        v-bind="{ segments, exportSelectedSegments }"
      />
      <ExportationFrameRunningChartSpeedCadence v-else class="top-margin" v-bind="{ segments }" />
    </ExportationViewerPage>
    <!--endregion-->

    <!--region PAGE 2-->
    <ExportationViewerPage v-if="detailledRunningMode && showDetails" :total="pageTotal" page="2">
      <ChartRunningDetailledTable
        v-bind="{ segments, displayMetrics }"
        :first-value="exportSelectedSegments[0]"
        :second-value="exportSelectedSegments[1] || null"
        :is-comparison-page="false"
        :imperial="currentUnit().isImperial.value"
      />
    </ExportationViewerPage>

    <ExportationViewerPage :total="pageTotal" :page="detailledRunningMode && showDetails ? 3 : 2">
      <ExportationFrameRunningChartRunProfile v-bind="{ aggregates, displayMetrics, norms }" />

      <ExportationFrameRunningChartPronationAngles
        v-bind="{ aggregates, displayMetrics, norms, advancedMode }"
        class="top-margin-lg bottom-margin-lg"
        :height="advancedMode ? 350 : 120"
      />
      <ExportationFrameRunningChartStrikePattern
        v-if="advancedMode"
        v-bind="{ aggregates, displayMetrics, norms, advancedMode }"
        class="top-margin-lg"
      />
      <ExportationFrameComments
        v-if="!advancedMode"
        v-bind="{ analysisComments: comments }"
        class="top-margin-lg"
      />
    </ExportationViewerPage>
    <!--Comments-->
    <ExportationViewerPage v-if="advancedMode" :total="pageTotal" page="3">
      <ExportationFrameComments
        v-bind="{ analysisComments: comments }"
        :vertical="advancedMode"
        :height="270"
      />
    </ExportationViewerPage>
    <!--endregion-->

    <!--endregion-->
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ExportationViewerPage from '@/components/exportation/ExportationViewerPage.vue';
import ExportationFrameHeader from '@/components/exportation/frames/ExportationFrameHeader.vue';
import ExportationFrameComments from '@/components/exportation/frames/ExportationFrameComments.vue';
// Charts
import ExportationFrameRunningChartBanner from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartBanner.vue';
import ExportationFrameRunningChartSpeedCadence from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartSpeedCadence.vue';
import ExportationFrameRunningChartRunProfile from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartRunProfile.vue';
import ExportationFrameRunningChartPronationAngles from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartPronationAngles.vue';
import ExportationFrameRunningChartStrikePattern from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartStrikePattern.vue';
import ExportationFrameRunningChartSpeedCadenceDetailled from '@/components/exportation/frames/running/charts/ExportationFrameRunningChartSpeedCadenceDetailled.vue';
import ChartRunningDetailledTable from '@/components/charts/running/ChartRunningDetailledTable.vue';
// Import utils ------------------------------------------------------------------------------------
import { useUnit } from '@/utils/unit.utils';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ExportationFrameRunning',
  components: {
    ExportationViewerPage,
    ExportationFrameHeader,
    ExportationFrameComments,
    // Charts
    ExportationFrameRunningChartBanner,
    ExportationFrameRunningChartSpeedCadence,
    ExportationFrameRunningChartRunProfile,
    ExportationFrameRunningChartPronationAngles,
    ExportationFrameRunningChartStrikePattern,
    ExportationFrameRunningChartSpeedCadenceDetailled,
    ChartRunningDetailledTable
  },
  props: {
    analysis: {
      type: Object,
      required: true
    },
    advancedMode: {
      type: Boolean,
      required: true
    },
    pageTotal: {
      type: Number,
      required: true,
      default: 0
    },
    headerInformations: {
      type: Object,
      required: true
    },
    detailledRunningMode: {
      type: Boolean
    },
    showDetails: {
      type: Boolean
    },
    exportSelectedSegments: {
      type: Array,
      required: false,
      default: () => []
    },
    comments: {
      type: Array,
      required: false
    }
  },
  setup(properties) {
    const { currentUnit } = useUnit();

    const aggregates = computed(() => properties.analysis.metrics.aggregates);
    const segments = computed(() => properties.analysis.metrics.segment);
    const displayMetrics = computed(() => properties.analysis.display_metrics);
    const norms = computed(() => properties.analysis.metrics.norms);

    return {
      aggregates,
      segments,
      displayMetrics,
      norms,
      //
      currentUnit
    };
  }
});
</script>

<style lang="scss" scoped>
.top-margin {
  margin-top: 30px;
  &-sm {
    margin-top: 20px;
  }
  &-lg {
    margin-top: 50px;
  }
}
</style>
